<template>
  <div class="content-panel">
    <a-input-search
      v-model="subcompanyname"
      style="margin-bottom: 8px"
      placeholder="请输入所属公司"
      @search="queryDictData"
      @pressEnter="queryDictData"
      v-if="showSearch"
    />
    <a-spin :spinning="loading" wrapperClassName="spin">
      <a-card :bordered="false">
        <!--默认展开的-->
        <!--        :defaultExpandedKeys="defaultSelectedKeys"-->
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :treeData="treeData"
          :draggable="false"
          @expand="onExpand"
          @select="searchAssetTypeList"
          :showIcon="false"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.subcompanyname }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getDeptTreeList } from '@/api/assetLedger'
export default {
  name: 'OrgTree',
  components: {
  },
  props: ['isOut', 'showSearch'],
  data () {
    return {
      expandedKeys: [],
      loading: false,
      subcompanyname: '',
      treeData: [],
      defaultSelectedKeys: [],
      selectedKeys: [],
      // 用于测试
      code: 'null0'
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  created () {
    // 获取使用部门
    this.getTableData()
  },
  methods: {
    ...mapActions(['handleBukrs']),
    onExpand (expandedKeys) {
      console.log(expandedKeys)
      this.expandedKeys = expandedKeys
    },
    formateData (arr, id, subcompanycode) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = id + ';' + item.id + Math.floor(Math.random() * 10)
          item.scopedSlots = { title: 'custom' }
          if (item.type === 2) {
            item.subcompanycode = subcompanycode
          }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children, item.id, item.subcompanycode)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取使用部门
    async getDeptData () {
      const data = {
        paging: false,
        id: 0,
        subcompanyname: this.subcompanyname
      }
      this.loading = true
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            item.key = String(item.id)
            item.scopedSlots = { title: 'custom' }
            item.children = this.formateData(item.children, item.id, item.subcompanycode)
          })
          this.defaultSelectedKeys = [res.data[0].key]
          this.selectedKeys = [res.data[0].key]
          this.treeData = res.data
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },

    getTableData () {
      for (let i = 0; i < 4; i++) {
        this.treeData.push({
          key: 1 + `a${i}`,
          id: 1 + `a${i}`,
          subcompanyname: '六万空分设备',
          number: 'ASAWEWDASD-001',
          hierarchy: '/',
          scopedSlots: { title: 'custom' },
          children: [
            {
              key: 11 + `b${i}`,
              id: 1 + `a${i}`,
              subcompanyname: '压缩机组',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              scopedSlots: { title: 'custom' },
              children: [
                {
                  key: 111 + `c${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 112 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 113 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 12 + `a${i}`,
              id: 1 + `a${i}`,
              subcompanyname: '空气预冷系统',
              number: 'ASAWEWDASD-001',
              scopedSlots: { title: 'custom' },
              hierarchy: '六万空分设备/',
              children: [
                {
                  key: 121 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 122 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 123 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 13 + `a${i}`,
              id: 1 + `a${i}`,
              subcompanyname: '分子筛纯化系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              scopedSlots: { title: 'custom' },
              children: [
                {
                  key: 131 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 132 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 133 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 14 + `a${i}`,
              id: 1 + `a${i}`,
              subcompanyname: '透平膨胀机系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              scopedSlots: { title: 'custom' },
              children: [
                {
                  key: 141 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 142 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 143 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 15 + `a${i}`,
              id: 1 + `a${i}`,
              subcompanyname: '分馏塔系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              scopedSlots: { title: 'custom' },
              children: [
                {
                  key: 151 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 152 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 153 + `a${i}`,
                  id: 1 + `a${i}`,
                  subcompanyname: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  scopedSlots: { title: 'custom' },
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            }
          ]
        })
      }
      this.tableData.data = this.analogData
    },
    // 调用父组件的获取资产类型数据方法
    searchAssetTypeList (data, info) {
      if (data.length > 0) {
        this.selectedKeys = data
        let id = ''
        // 存subcompanycode到VueX中，并且在资产文件和表格文件中做监听
        if (info.selectedNodes.length > 0) {
          id = info.selectedNodes[0].data.props.id
        }
        // this.handleBukrs(id)
      }
    },
    // 搜索设备分类
    queryDictData () {
      this.getDeptData()
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-switcher_close{
          background: url('../../../../src/assets/icon-close.svg') no-repeat 5px 4px !important;
          svg{
            display: none !important;
          }
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
</style>
